import MsApiAbstract from '@services/api/ms'

import { AZURE } from '@features/hooks/LandingZones'

class LandingZoneMigrationApi extends MsApiAbstract {
    static migrationStatus(lzId, callback = null, mode = AZURE, type = 'lzManager', scopes = '/user_impersonation', headers = {'x-api-version': '1.0'}, execCallback = true) {
        return this.getProcess(`/api/landing-zones/${lzId}/migration-status`, {mode, type, scopes, headers, callback, execCallback})
    }

    static loadInterLzs(lzId, callback = null, mode = AZURE, type = 'lzManager', scopes = '/user_impersonation', headers = {'x-api-version': '1.0'}, execCallback = true) {
        return this.getProcess(`/api/landing-zones/${lzId}/inter-landing-zones`, {mode, type, scopes, headers, callback, execCallback})
    }

    static loadDefaultRoute(lzId, callback = null, mode = AZURE, type = 'logs', scopes = '/user_impersonation', headers = {'x-api-version': '4.0'}, execCallback = true) {
        return this.getProcess(`/api/landing-zones/${lzId}/route-tables`, {mode, type, scopes, headers, callback, execCallback})
    }

    static loadFlowLogs(lzId, callback = null, mode = AZURE, type = 'logs', scopes = '/user_impersonation', headers = {'x-api-version': '4.0'}, execCallback = true) {
        return this.getProcess(`/api/landing-zones/${lzId}/unmanaged-onpremise-flows`, {mode, type, scopes, headers, callback, execCallback})
    }

    static loadAppLogs(lzId, callback = null, mode = AZURE, type = 'logs', scopes = '/user_impersonation', headers = {'x-api-version': '4.0'}, execCallback = true) {
        return this.getProcess(`/api/landing-zones/${lzId}/private-app-gateways`, {mode, type, scopes, headers, callback, execCallback})
    }

    static action(lzId, step, action, callback = null, mode = AZURE, type = 'patrol', scopes = '/user_impersonation', headers = {'x-api-version': '1.0'}, execCallback = true) {
        return this.postProcess(`/api/landing-zones/${lzId}/migrations/${step}/actions/${action}`, {}, {mode, type, scopes, headers, callback, execCallback, okStatus: 204})
    }

    static terminate(lzId, callback = null, mode = AZURE, type = 'patrol', scopes = '/user_impersonation', headers = {'x-api-version': '1.0'}, execCallback = true) {
        return this.postProcess(`/api/landing-zones/${lzId}/migrations/terminate`, {}, {mode, type, scopes, headers, callback, execCallback, okStatus: 204})
    }
}

export default LandingZoneMigrationApi